<div class="ui basic padded fitted horizontally segment">
  <h3 class="ui header fw-100">Opening Hours</h3>
  <div>
    <table class="ui celled unstackable very basic table">
      <tbody>
        <tr *ngFor="let screenHour of screenHours">
          <td>
            {{ screenHour.day }}
          </td>
          <td>
            <div class="ui basic labels">
              <a class="ui label" *ngFor="let slot of screenHour.slots">
                {{ slot.startTime }} to {{ slot.endTime }}
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
